/**
 * Auth Service — wraps the Odoo OTP flow for browser use.
 * Calls are routed through the CRA proxy to avoid CORS.
 */

const BASE = '';            // hits the proxy (setupProxy.js → Odoo)
const DB   = 'e18_rpc_test';

const jsonrpc = async (endpoint, params) => {
  const res = await fetch(`${BASE}${endpoint}`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      jsonrpc: '2.0',
      method:  'call',
      params,
      id: Math.floor(Math.random() * 10000)
    })
  });
  const data = await res.json();
  if (data.error) {
    throw new Error(
      data.error.data?.message || data.error.message || 'Odoo RPC error'
    );
  }
  return data.result;
};

/** Request a login OTP for an existing account */
export const requestLoginOTP = (email) =>
  jsonrpc('/jsonrpc', {
    service: 'common',
    method:  'login_email_otp',
    args:    [DB, email, 'website']
  });

/** Verify a login OTP and return auth data */
export const verifyLoginOTP = async (email, otp) => {
  const result = await jsonrpc('/jsonrpc', {
    service: 'common',
    method:  'verify_otp',
    args:    [DB, email, otp, 'website']
  });
  if (!result || result.error || result.faultCode) {
    throw new Error(result?.error || result?.faultString || 'Invalid OTP');
  }
  return {
    uid:     result.uid || result.user_id || result.id,
    api_key: result.api_key || result.apiKey || result.key || null,
    name:    result.name || email.split('@')[0],
    email
  };
};

/** Request a signup OTP for a new account */
export const requestSignupOTP = (email, name) =>
  jsonrpc('/jsonrpc', {
    service: 'common',
    method:  'signup_via_otp',
    args:    [DB, email, { name: name.trim(), user_tz: 'Asia/Kolkata' }]
  });

/** Verify a signup OTP and finalise account creation */
export const verifySignupOTP = (email, otp) =>
  jsonrpc('/jsonrpc', {
    service: 'common',
    method:  'signup_verify_otp',
    args:    [DB, email, otp]
  });

/* ─── Local session helpers ─── */
const SESSION_KEY = 'xamta_auth';

export const saveSession = (user) =>
  localStorage.setItem(SESSION_KEY, JSON.stringify(user));

export const getSession = () => {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY)); }
  catch { return null; }
};

export const clearSession = () => localStorage.removeItem(SESSION_KEY);
